export const templatePostDetail = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Cacio e Pepe — nonna's version — Nemonto</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30; --spice-deep:#B23D18; --cream:#FAECE7; --peach:#F5C4B3;
    --charcoal:#2C2C2A; --herb:#1D9E75; --gold:#FAC775; --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif; --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{background:#F1E4DE; color:var(--charcoal); font-family:var(--sans); font-size:14px; height:100vh; overflow:hidden;}
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:2px; border-radius:4px;}
  ::-webkit-scrollbar{width:7px;}
  ::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.14); border-radius:10px;}
  ::-webkit-scrollbar-track{background:transparent;}

  .app{display:grid; grid-template-columns:264px minmax(0,1fr) 300px; height:100vh; width:100%; max-width:none; margin:0;}

  /* ============ LEFT SIDEBAR ============ */
  .sidebar{padding:26px 18px; display:flex; flex-direction:column; height:100vh; border-right:1px solid rgba(44,44,42,0.07);}
  .brand{display:flex; align-items:center; gap:9px; font-family:var(--serif); font-size:21px; padding:0 10px 28px;}
  .nav-item{display:flex; align-items:center; gap:13px; padding:11px 12px; border-radius:14px; width:100%; font-size:15px; font-weight:500; color:#6B5F58; transition:background .15s, color .15s;}
  .nav-item:hover{background:rgba(44,44,42,0.04);}
  .nav-item.active{background:var(--spice); color:var(--cream);}
  .nav-icon{width:21px; height:21px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .nav-badge{margin-left:auto; background:var(--gold); color:#5A3A00; font-size:10.5px; font-weight:700; padding:2px 7px; border-radius:20px;}
  .nav-item.active .nav-badge{background:rgba(250,236,231,0.25); color:var(--cream);}
  .post-btn{margin:18px 10px 22px; background:var(--spice); color:var(--cream); padding:13px; border-radius:16px; font-size:14.5px; font-weight:700; display:flex; align-items:center; justify-content:center; gap:8px; transition:transform .15s, box-shadow .15s;}
  .post-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .sidebar-spacer{flex:1;}
  .profile-mini{display:flex; align-items:center; gap:10px; padding:9px 10px; border-radius:14px;}
  .pm-avatar{width:38px; height:38px; border-radius:50%; background:#9FE1CB; flex-shrink:0;}
  .pm-name{font-size:13.5px; font-weight:600;}
  .pm-handle{font-size:11.5px; color:#9A8C84;}
  .pm-more{margin-left:auto; color:#9A8C84;}

  /* ============ CENTER — POST ============ */
  .post-col{height:100vh; overflow-y:auto; border-right:1px solid rgba(44,44,42,0.07);}
  .back-row{display:flex; align-items:center; gap:10px; padding:18px 28px 0; font-size:13px; color:#9A8C84; font-weight:600;}
  .back-row svg{flex-shrink:0;}

  .post-wrap{padding:16px 28px 60px; max-width:none;}

  .author-row{display:flex; align-items:center; gap:11px; margin-bottom:16px;}
  .author-avatar{width:42px; height:42px; border-radius:50%; flex-shrink:0;}
  .author-name{font-size:14.5px; font-weight:600; display:flex; align-items:center; gap:6px;}
  .author-meta{font-size:12px; color:#9A8C84;}
  .follow-pill{margin-left:auto; background:var(--spice); color:#fff; font-size:12px; font-weight:700; padding:8px 16px; border-radius:30px;}
  .follow-pill.following{background:#fff; border:1.5px solid rgba(44,44,42,0.14); color:var(--charcoal);}
  .more-icon{color:#B6A89F; font-size:16px; margin-left:8px;}

  .media-box{
    height:340px; border-radius:22px; position:relative; overflow:hidden; display:flex; align-items:center; justify-content:center;
    margin-bottom:18px;
  }
  .challenge-flag{position:absolute; top:14px; left:14px; background:var(--charcoal); color:var(--gold); font-size:11px; font-weight:700; padding:5px 11px; border-radius:20px; display:flex; align-items:center; gap:5px;}
  .play-overlay{position:absolute; bottom:14px; right:14px; width:42px; height:42px; border-radius:50%; background:rgba(255,255,255,0.92); display:flex; align-items:center; justify-content:center; color:var(--spice-deep);}

  .post-title{font-family:var(--serif); font-size:26px; line-height:1.2; margin-bottom:8px;}
  .post-desc{font-size:14.5px; color:#5A4F49; line-height:1.6; margin-bottom:18px;}

  .action-bar{display:flex; align-items:center; gap:20px; padding:14px 0; border-top:1px solid rgba(44,44,42,0.08); border-bottom:1px solid rgba(44,44,42,0.08); margin-bottom:22px;}
  .ab-btn{display:flex; align-items:center; gap:7px; font-size:14px; font-weight:600; color:#6B5F58;}
  .ab-btn.liked{color:var(--spice-deep);}
  .ab-btn svg{flex-shrink:0;}
  .made-it-cta{margin-left:auto; background:var(--spice); color:#fff; font-size:13.5px; font-weight:700; padding:10px 20px; border-radius:30px; display:flex; align-items:center; gap:7px; transition:transform .15s, box-shadow .15s;}
  .made-it-cta:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}

  .recipe-stats{display:grid; grid-template-columns:repeat(4,1fr); gap:10px; margin-bottom:24px;}
  .rstat{background:#fff; border-radius:14px; padding:12px; text-align:center; border:1px solid rgba(44,44,42,0.06);}
  .rstat b{display:block; font-family:var(--serif); font-size:17px; color:var(--spice-deep);}
  .rstat span{font-size:10.5px; color:#9A8C84;}

  .recipe-section{margin-bottom:26px;}
  .rs-head{font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--spice-deep); margin-bottom:12px;}
  .ingredient-list{display:flex; flex-direction:column; gap:9px;}
  .ingredient-item{display:flex; align-items:center; gap:10px; font-size:14px; color:#3A3330;}
  .ing-check{width:18px; height:18px; border-radius:5px; border:1.5px solid rgba(44,44,42,0.18); flex-shrink:0;}
  .ing-check.checked{background:var(--herb); border-color:var(--herb); display:flex; align-items:center; justify-content:center;}

  .step-list{display:flex; flex-direction:column; gap:16px;}
  .step-item{display:flex; gap:14px;}
  .step-num{width:28px; height:28px; border-radius:50%; background:var(--cream); color:var(--spice-deep); font-family:var(--serif); font-size:13px; display:flex; align-items:center; justify-content:center; flex-shrink:0;}
  .step-text{font-size:14px; color:#3A3330; line-height:1.55; padding-top:3px;}

  .creator-note{background:#fff; border-radius:16px; padding:16px 18px; border-left:3px solid var(--gold); margin-bottom:8px;}
  .creator-note p{font-family:var(--serif); font-style:italic; font-size:14.5px; color:#5A4F49; line-height:1.55;}

  /* MADE IT THREAD */
  .thread-head{display:flex; align-items:center; justify-content:space-between; margin-bottom:16px; padding-top:8px; border-top:1px solid rgba(44,44,42,0.08);}
  .thread-head h2{font-family:var(--serif); font-size:19px; padding-top:18px;}
  .thread-filter{display:flex; gap:6px; margin-bottom:18px; flex-wrap:wrap;}
  .tf-pill{font-size:12px; font-weight:600; padding:6px 13px; border-radius:20px; background:#fff; border:1px solid rgba(44,44,42,0.1); color:#6B5F58;}
  .tf-pill.active{background:var(--spice); color:#fff; border-color:var(--spice);}

  .reply-composer{display:flex; gap:10px; align-items:center; background:#fff; border-radius:30px; padding:8px 8px 8px 16px; margin-bottom:22px; border:1px solid rgba(44,44,42,0.06);}
  .reply-composer input{flex:1; border:none; outline:none; background:none; font-size:13.5px; font-family:var(--sans); color:var(--charcoal);}
  .reply-composer input::placeholder{color:#B6A89F;}
  .reply-submit{background:var(--spice); color:#fff; font-size:12.5px; font-weight:700; padding:10px 18px; border-radius:24px;}

  .reply-card{background:#fff; border-radius:18px; padding:16px; margin-bottom:14px; border:1px solid rgba(44,44,42,0.06);}
  .reply-top{display:flex; align-items:center; gap:9px; margin-bottom:10px;}
  .reply-avatar{width:34px; height:34px; border-radius:50%; flex-shrink:0;}
  .reply-name{font-size:13px; font-weight:600;}
  .reply-time{font-size:11px; color:#9A8C84;}
  .reaction-badge{margin-left:auto; font-size:10.5px; font-weight:700; padding:4px 10px; border-radius:20px;}
  .reaction-badge.nailed{background:#E1F5EE; color:#085041;}
  .reaction-badge.twist{background:#FAEEDA; color:#633806;}
  .reaction-badge.almost{background:#F1E4DE; color:#6B5F58;}
  .reaction-badge.winner{background:rgba(250,199,117,0.25); color:#8A5A00;}
  .reply-media{height:140px; border-radius:13px; margin-bottom:10px; display:flex; align-items:center; justify-content:center;}
  .reply-text{font-size:13.5px; color:#3A3330; line-height:1.55; margin-bottom:10px;}
  .reply-actions{display:flex; gap:16px; font-size:12px; color:#9A8C84; font-weight:600;}
  .reply-actions span.liked{color:var(--spice-deep);}

  .winner-reply{border:1.5px solid var(--gold); background:rgba(250,199,117,0.06);}
  .winner-tag{display:flex; align-items:center; gap:6px; font-size:11px; font-weight:700; color:#8A5A00; margin-bottom:8px;}

  /* ============ RIGHT RAIL ============ */
  .right-rail{height:100vh; overflow-y:auto; padding:24px 20px 40px;}
  .rail-block{margin-bottom:26px;}
  .rail-head{display:flex; align-items:center; justify-content:space-between; margin-bottom:14px;}
  .rail-head h3{font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#6B5F58;}

  .creator-card{background:#fff; border-radius:18px; padding:18px; border:1px solid rgba(44,44,42,0.06); text-align:center; margin-bottom:14px;}
  .cc-avatar{width:60px; height:60px; border-radius:50%; margin:0 auto 10px; position:relative;}
  .cc-ring{position:absolute; inset:-3px; border-radius:50%; border:2px solid var(--gold);}
  .cc-name{font-size:14.5px; font-weight:600; margin-bottom:2px;}
  .cc-handle{font-size:12px; color:#9A8C84; margin-bottom:10px;}
  .cc-stats{display:flex; justify-content:center; gap:16px; margin-bottom:14px;}
  .cc-stat b{display:block; font-size:14px; font-family:var(--serif);}
  .cc-stat span{font-size:10px; color:#9A8C84;}
  .cc-follow{width:100%; background:var(--spice); color:#fff; font-size:13px; font-weight:700; padding:9px 0; border-radius:14px;}

  .cart-card{background:var(--charcoal); border-radius:18px; padding:18px; position:relative; overflow:hidden;}
  .cart-card::before{content:''; position:absolute; top:-50px; right:-40px; width:120px; height:120px; background:radial-gradient(circle, rgba(216,90,48,0.4), transparent 70%);}
  .cart-card p.cc-label{font-size:10.5px; letter-spacing:0.06em; text-transform:uppercase; color:var(--gold); margin-bottom:8px; position:relative;}
  .cart-card p.cc-title{font-family:var(--serif); font-size:15px; color:var(--cream); line-height:1.3; margin-bottom:12px; position:relative;}
  .cart-btn{display:block; text-align:center; background:var(--gold); color:#5A3A00; font-size:12.5px; font-weight:700; padding:9px 0; border-radius:12px; position:relative;}

  .related-card{display:flex; gap:11px; align-items:center; padding:8px 0; border-bottom:1px solid rgba(44,44,42,0.06);}
  .related-card:last-child{border-bottom:none;}
  .rc-thumb{width:50px; height:50px; border-radius:11px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .rc-info b{font-size:12.5px; font-weight:600; display:block; margin-bottom:2px;}
  .rc-info span{font-size:11px; color:#9A8C84;}

  @media (max-width:1180px){
    .app{grid-template-columns:84px minmax(0,1fr) 300px;}
    .brand span.brand-text, .nav-item span.nav-label, .post-btn span.btn-label, .pm-name, .pm-handle{display:none;}
    .nav-item{justify-content:center;} .nav-badge{display:none;} .post-btn{padding:13px;} .profile-mini{justify-content:center;}
  }
  @media (max-width:900px){
    .app{grid-template-columns:84px minmax(0,1fr);}
    .right-rail{display:none;}
  }
</style>
</head>
<body>

<div class="app">

  <!-- ================= LEFT SIDEBAR ================= -->
  <aside class="sidebar">
    <div class="brand">
      <img src="../image/nemonto-logo.png" alt="Nemonto" style="height:32px; width:auto; display:block;" />
    </div>
    <nav>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 11l8-7 8 7M6 10v9a1 1 0 001 1h4v-6h2v6h4a1 1 0 001-1v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Home</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Explore</span>
      </a>
      <a class="nav-item active" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Made it</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 21V5a1 1 0 011-1h14a1 1 0 011 1v16l-8-4-8 4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Challenges</span>
        <span class="nav-badge">3 live</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20.8 4.6c-1.5-1.5-4-1.5-5.6.1L12 7.9 8.8 4.7c-1.6-1.6-4.1-1.6-5.6-.1-1.5 1.5-1.5 4 .1 5.6L12 19l8.7-8.8c1.6-1.6 1.6-4.1.1-5.6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Saved</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 11.5a8.4 8.4 0 01-1.2 4.4L21 20l-4.3-1.2a8.5 8.5 0 11-1.8-15.6 8.5 8.5 0 016.1 7.3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Messages</span>
        <span class="nav-badge">2</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="8" r="3.4" stroke="currentColor" stroke-width="1.6"/><path d="M3 19c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Profile</span>
      </a>
    </nav>
    <div class="post-btn">
      <svg width="17" height="17" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      <span class="btn-label">New recipe</span>
    </div>
    <div class="sidebar-spacer"></div>
    <div class="profile-mini">
      <div class="pm-avatar"></div>
      <div><div class="pm-name">Priya Rajan</div><div class="pm-handle">@priyacooks</div></div>
      <span class="pm-more">⋯</span>
    </div>
  </aside>

  <!-- ================= CENTER — POST ================= -->
  <main class="post-col">
    <div class="back-row">
      <svg width="16" height="16" viewBox="0 0 16 16"><path d="M10 13L5 8l5-5" stroke="#9A8C84" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
      Back to feed
    </div>

    <div class="post-wrap">

      <div class="author-row">
        <div class="author-avatar" style="background:#F0997B;"></div>
        <div>
          <div class="author-name">Maria K. 🏅</div>
          <div class="author-meta">Italian · Posted 12 min ago</div>
        </div>
        <button class="follow-pill">Follow</button>
        <span class="more-icon">⋯</span>
      </div>

      <div class="media-box" style="background:linear-gradient(150deg,#E8916F,#B23D18);">
        <svg width="80" height="80" viewBox="0 0 100 100" aria-hidden="true">
          <ellipse cx="50" cy="76" rx="32" ry="6" fill="#7A2A0A" opacity="0.4"/>
          <path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.9"/>
          <path d="M16 47 Q16 53 21 53 L79 53 Q84 53 84 47 Q84 38 50 38 Q16 38 16 47 Z" fill="#fff"/>
        </svg>
        <span class="challenge-flag">⚑ Submitted to a challenge</span>
        <div class="play-overlay">
          <svg width="16" height="16" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg>
        </div>
      </div>

      <h1 class="post-title">Cacio e Pepe — nonna's version</h1>
      <p class="post-desc">Only 3 ingredients. Takes 15 minutes. The secret is whisking the pasta water in slowly — never let the pan get too hot or the cheese will seize up on you.</p>

      <div class="action-bar">
        <span class="ab-btn liked" id="likeBtn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.5-4.6-10-9.3C0.5 8 2 4.5 5.5 3.6 8 3 10.3 4 12 6.3 13.7 4 16 3 18.5 3.6 22 4.5 23.5 8 22 11.7 19.5 16.4 12 21 12 21z"/></svg>
          <span id="likeCount">142</span>
        </span>
        <span class="ab-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>
          38
        </span>
        <span class="ab-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 12v7a1 1 0 001 1h14a1 1 0 001-1v-7M16 6l-4-4-4 4M12 2v14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Share
        </span>
        <span class="ab-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20.8 4.6c-1.5-1.5-4-1.5-5.6.1L12 7.9 8.8 4.7c-1.6-1.6-4.1-1.6-5.6-.1-1.5 1.5-1.5 4 .1 5.6L12 19l8.7-8.8c1.6-1.6 1.6-4.1.1-5.6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>
          Save
        </span>
        <button class="made-it-cta">
          🍳 Made it?
        </button>
      </div>

      <div class="recipe-stats">
        <div class="rstat"><b>15 min</b><span>Cook time</span></div>
        <div class="rstat"><b>2</b><span>Servings</span></div>
        <div class="rstat"><b>47</b><span>Made it</span></div>
        <div class="rstat"><b>Italian</b><span>Cuisine</span></div>
      </div>

      <div class="recipe-section">
        <p class="rs-head">Ingredients</p>
        <div class="ingredient-list">
          <div class="ingredient-item"><div class="ing-check"></div>200g spaghetti</div>
          <div class="ingredient-item"><div class="ing-check"></div>100g Pecorino Romano, finely grated</div>
          <div class="ingredient-item"><div class="ing-check"></div>2 tsp coarse black pepper</div>
          <div class="ingredient-item"><div class="ing-check checked"><svg width="10" height="10" viewBox="0 0 10 10"><path d="M1 5l3 3 5-6" stroke="#fff" stroke-width="1.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></div>Reserved pasta water</div>
        </div>
      </div>

      <div class="recipe-section">
        <p class="rs-head">Steps</p>
        <div class="step-list">
          <div class="step-item">
            <div class="step-num">1</div>
            <div class="step-text">Toast the cracked pepper in a dry pan for 30 seconds until fragrant. Set aside.</div>
          </div>
          <div class="step-item">
            <div class="step-num">2</div>
            <div class="step-text">Boil the spaghetti one minute under package time. Reserve a full cup of starchy pasta water before draining.</div>
          </div>
          <div class="step-item">
            <div class="step-num">3</div>
            <div class="step-text">Off the heat, whisk Pecorino into a splash of pasta water slowly — too fast and it clumps. Build a smooth, glossy sauce.</div>
          </div>
          <div class="step-item">
            <div class="step-num">4</div>
            <div class="step-text">Toss the pasta through the sauce with the toasted pepper. Add more pasta water if it tightens up.</div>
          </div>
        </div>
      </div>

      <div class="creator-note">
        <p>"My nonna never measured anything — this is me trying to write down what her hands already knew."</p>
      </div>

      <!-- ===== MADE IT THREAD ===== -->
      <div class="thread-head">
        <h2>Made it — 47 replies</h2>
      </div>

      <div class="thread-filter">
        <span class="tf-pill active">All 47</span>
        <span class="tf-pill">🔥 Nailed it · 31</span>
        <span class="tf-pill">🔄 My twist · 9</span>
        <span class="tf-pill">😅 Almost · 7</span>
      </div>

      <div class="reply-composer">
        <div class="reply-avatar" style="background:#9FE1CB; width:30px; height:30px;"></div>
        <input type="text" placeholder="Made this? Share how it went...">
        <button class="reply-submit">Post</button>
      </div>

      <!-- winner reply (challenge context) -->
      <div class="reply-card winner-reply">
        <span class="winner-tag">🏆 Challenge winner — chosen by Maria</span>
        <div class="reply-top">
          <div class="reply-avatar" style="background:#9FE1CB;"></div>
          <div>
            <div class="reply-name">Priya R. 🏅</div>
            <div class="reply-time">Today</div>
          </div>
          <span class="reaction-badge nailed">🔥 Nailed it</span>
        </div>
        <div class="reply-media" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
          <svg width="34" height="34" viewBox="0 0 100 100"><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.9"/></svg>
        </div>
        <p class="reply-text">Used the pasta water trick exactly like you said — went from grainy to silky the second time around. 12 minutes flat.</p>
        <div class="reply-actions"><span class="liked">♥ 24</span><span>💬 Reply</span></div>
      </div>

      <div class="reply-card">
        <div class="reply-top">
          <div class="reply-avatar" style="background:#AFA9EC;"></div>
          <div>
            <div class="reply-name">James L.</div>
            <div class="reply-time">3 hours ago</div>
          </div>
          <span class="reaction-badge twist">🔄 My twist</span>
        </div>
        <div class="reply-media" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
          <svg width="34" height="34" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg>
        </div>
        <p class="reply-text">Added a little lemon zest at the end — cuts through the richness nicely. Still very much your recipe though.</p>
        <div class="reply-actions"><span>♥ 11</span><span>💬 Reply</span></div>
      </div>

      <div class="reply-card">
        <div class="reply-top">
          <div class="reply-avatar" style="background:#FAC775;"></div>
          <div>
            <div class="reply-name">Sofia M. 🏅</div>
            <div class="reply-time">5 hours ago</div>
          </div>
          <span class="reaction-badge almost">😅 Almost</span>
        </div>
        <p class="reply-text">First attempt clumped on me but I think I added the cheese too fast. Trying again tomorrow with your "slow whisk" tip.</p>
        <div class="reply-actions"><span>♥ 6</span><span>💬 Reply</span></div>
      </div>

      <div class="reply-card">
        <div class="reply-top">
          <div class="reply-avatar" style="background:#F5C4B3;"></div>
          <div>
            <div class="reply-name">Chen W.</div>
            <div class="reply-time">Yesterday</div>
          </div>
          <span class="reaction-badge nailed">🔥 Nailed it</span>
        </div>
        <p class="reply-text">Didn't expect 3 ingredients to taste this good. My kitchen smells like a trattoria right now.</p>
        <div class="reply-actions"><span>♥ 18</span><span>💬 Reply</span></div>
      </div>

    </div>
  </main>

  <!-- ================= RIGHT RAIL ================= -->
  <aside class="right-rail">

    <div class="rail-block">
      <div class="creator-card">
        <div class="cc-avatar" style="background:#F0997B;"><div class="cc-ring"></div></div>
        <p class="cc-name">Maria K.</p>
        <p class="cc-handle">@mariakcooks · Founding Creator</p>
        <div class="cc-stats">
          <div class="cc-stat"><b>62</b><span>Recipes</span></div>
          <div class="cc-stat"><b>8.2k</b><span>Followers</span></div>
          <div class="cc-stat"><b>389</b><span>Made its</span></div>
        </div>
        <button class="cc-follow">Follow Maria</button>
      </div>
    </div>

    <div class="rail-block">
      <div class="cart-card">
        <p class="cc-label">Shop this recipe</p>
        <p class="cc-title">Add Pecorino &amp; spaghetti to your cart</p>
        <a href="#" class="cart-btn">Order ingredients</a>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>More from Maria</h3></div>
      <div class="related-card">
        <div class="rc-thumb" style="background:linear-gradient(150deg,#FCD58E,#BA7517);">
          <svg width="24" height="24" viewBox="0 0 100 100"><path d="M24 48 Q24 70 50 70 Q76 70 76 48 Z" fill="#fff" opacity="0.85"/></svg>
        </div>
        <div class="rc-info"><b>No-knead focaccia</b><span>61 made it</span></div>
      </div>
      <div class="related-card">
        <div class="rc-thumb" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
          <svg width="24" height="24" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg>
        </div>
        <div class="rc-info"><b>Sunday ragù, slow simmered</b><span>34 made it</span></div>
      </div>
      <div class="related-card">
        <div class="rc-thumb" style="background:linear-gradient(150deg,#E8693D,#993C1D);">
          <svg width="24" height="24" viewBox="0 0 100 100"><circle cx="50" cy="50" r="22" fill="#fff" opacity="0.6"/></svg>
        </div>
        <div class="rc-info"><b>Tomato and burrata</b><span>73 made it</span></div>
      </div>
    </div>

  </aside>

</div>

<script>
  document.querySelectorAll('.follow-pill, .cc-follow').forEach(btn => {
    btn.addEventListener('click', () => {
      const following = btn.classList.toggle('following');
      btn.textContent = following ? 'Following' : (btn.classList.contains('cc-follow') ? 'Follow Maria' : 'Follow');
    });
  });

  document.querySelectorAll('.thread-filter .tf-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      document.querySelectorAll('.thread-filter .tf-pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
    });
  });

  document.querySelectorAll('.ingredient-item .ing-check').forEach(box => {
    box.addEventListener('click', () => {
      const checked = box.classList.toggle('checked');
      box.innerHTML = checked ? '<svg width="10" height="10" viewBox="0 0 10 10"><path d="M1 5l3 3 5-6" stroke="#fff" stroke-width="1.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '';
    });
  });

  const likeBtn = document.getElementById('likeBtn');
  const likeCount = document.getElementById('likeCount');
  let liked = true, count = 142;
  likeBtn.addEventListener('click', () => {
    liked = !liked;
    count = liked ? count + 1 : count - 1;
    likeCount.textContent = count;
    likeBtn.classList.toggle('liked', liked);
  });
</script>

</body>
</html>

`;
